document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href]');
  if (!link) return;

  let url;
  try {
    url = new URL(link.href, window.location.href);
  } catch (e) {
    return;
  }

  if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || !url.hash) return;

  let target;
  try {
    target = document.querySelector(url.hash);
  } catch (e) {
    return;
  }
  if (!target) return;

  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});
